// Spacing between columns, columns and viewport edges, and columns and banner
export const gutterSize = 30

export const bannerHeight = 75
export const maxColWidth = 550

// for columns with overflow-y: scroll. Subtract top + bottom gutter and banner height from 100vh + ~4px worth of border
export const verticalSpace = gutterSize * 2 + bannerHeight + 4

// colors
export const textColor = '#333'
export const backgroundColor = '#f5f5f5'
export const blue = '#136cff'
export const lightBlue = '#13aeff'
export const gray = '#8a8a8a'
export const lightGray = '#bbb'
export const leftBackgroundColor = '#E7E8EE'
export const rightBackgroundColor = '#FEEFE7'
